import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import { sendConfirmationEmail } from '../../../userUtils';
function ReferralRow(_ref) {
  var referral = _ref.referral,
    csrfToken = _ref.csrfToken,
    userType = _ref.userType;
  var sendReminderEmail = function sendReminderEmail(event) {
    event.preventDefault();
    sendConfirmationEmail(event, referral.resend_invitation_link, referral.email, csrfToken, "".concat(userType === 'consultant' ? 'Consultant' : 'Employer', " Referral Program"), 'Reminder sent!');
  };
  var progressClass = referral.ignored ? 'bg-default-light' : 'bg-primary-light';
  var hideProgressClass = referral.ignored || referral.completed ? 'd-none d-sm-block' : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "referral-row row body-text-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-2 referral-id ".concat(referral.ignored ? 'text-muted' : '')
  }, referral.user_identifier), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8 small ".concat(progressClass, " ").concat(hideProgressClass)
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: referral.percent_complete
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-2"
  }, referral.reward_claimed && /*#__PURE__*/React.createElement("span", {
    className: "signed-up"
  }, "Reward claimed!"), referral.ignored && /*#__PURE__*/React.createElement("span", {
    className: "signed-up text-muted"
  }, "Already a member!"), referral.completed && !referral.reward_claimed && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "line-one"
  }, "Successful Referral!"), /*#__PURE__*/React.createElement("span", {
    className: "line-two"
  }, "Check your inbox.")), referral.pending && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "line-one"
  }, "Pending invitation."), /*#__PURE__*/React.createElement("span", {
    className: "line-two"
  }, /*#__PURE__*/React.createElement("a", {
    href: "# ",
    role: "button",
    className: "".concat(userType, "-send-referral-reminder"),
    onClick: sendReminderEmail
  }, "Send a reminder?")))), /*#__PURE__*/React.createElement("div", {
    className: "border"
  }));
}
ReferralRow.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referral: PropTypes.shape({}).isRequired,
  userType: PropTypes.bool.isRequired
};
var ReferralsList = /*#__PURE__*/function (_Component) {
  function ReferralsList(props) {
    var _this;
    _classCallCheck(this, ReferralsList);
    _this = _callSuper(this, ReferralsList, [props]);
    _this.state = {
      show: false
    };
    _this.showAll = _this.showAll.bind(_this);
    return _this;
  }
  _inherits(ReferralsList, _Component);
  return _createClass(ReferralsList, [{
    key: "showAll",
    value: function showAll() {
      var show = this.state.show;
      this.setState({
        show: !show
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        referrals = _this$props.referrals,
        userType = _this$props.userType,
        csrfToken = _this$props.csrfToken,
        headerTitle = _this$props.headerTitle;
      var show = this.state.show;
      var sortedReferrals = referrals.sort(function (a, b) {
        return b.percent_complete - a.percent_complete;
      });
      var referralsToShow = show ? sortedReferrals : sortedReferrals.slice(0, 5);
      if (referrals.length > 0) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
          className: " mb-3 "
        }, headerTitle), /*#__PURE__*/React.createElement("div", {
          className: "row referral-header  mb-3  d-none d-sm-block"
        }, /*#__PURE__*/React.createElement("span", {
          className: "col-sm-2"
        }), /*#__PURE__*/React.createElement("span", {
          className: "col-sm-2 text-center body-text-2 medium-demibold"
        }, "Invited"), /*#__PURE__*/React.createElement("span", {
          className: "col-sm-2 text-center body-text-2 medium-demibold"
        }, "Signed up"), /*#__PURE__*/React.createElement("span", {
          className: "col-sm-2 text-center body-text-2 medium-demibold"
        }, userType === 'consultant' ? 'Applied' : /*#__PURE__*/React.createElement("span", null, "Project", /*#__PURE__*/React.createElement("br", null), "published")), /*#__PURE__*/React.createElement("span", {
          className: "col-sm-2 text-center body-text-2 medium-demibold"
        }, userType === 'consultant' ? 'Hired' : /*#__PURE__*/React.createElement("span", null, "Project", /*#__PURE__*/React.createElement("br", null), "matched")), /*#__PURE__*/React.createElement("span", {
          className: "col-sm-2"
        })), referralsToShow.map(function (referral) {
          return /*#__PURE__*/React.createElement(ReferralRow, {
            referral: referral,
            key: "referral-".concat(referral.id),
            csrfToken: csrfToken,
            userType: userType
          });
        }), referrals.length > 5 && /*#__PURE__*/React.createElement("div", {
          className: "text-center"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-secondary",
          onClick: function onClick() {
            return _this2.showAll();
          }
        }, show ? 'View fewer invites' : "Show all invites (".concat(referrals.length, ")"))));
      }
      return null;
    }
  }]);
}(Component);
ReferralsList.propTypes = {
  referrals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  headerTitle: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  userType: PropTypes.bool.isRequired
};
ReferralsList.defaultProps = {
  headerTitle: null
};
export default ReferralsList;